import { EmbeddedRouteName, RouteName } from '@/shared/enums';
import routes from '@/embedded-player/router/routes';

const PLAYER_ID = 'tv3play-embedded-player';
const EP_WIDTH = 780;
const EP_HIGHT = 439;

export default {
  computed: {
    embeddedCode() {
      const routesNames = {
        [RouteName.DETAIL]: EmbeddedRouteName.PLAYER,
        [RouteName.DETAIL_WITH_ARTICLE]: EmbeddedRouteName.PLAYER_WITH_ARTICLE,
        [EmbeddedRouteName.PLAYER]: EmbeddedRouteName.PLAYER,
        [EmbeddedRouteName.PLAYER_WITH_ARTICLE]: EmbeddedRouteName.PLAYER_WITH_ARTICLE,
      };
      const embeddedRouteName = routesNames[this.$route.name];
      const route = routes.find(({ name }) => name === embeddedRouteName);

      if (!embeddedRouteName || !route) {
        return this.$t('share.embedCode.error');
      }

      const { slug, type, id, articleSlug, articleType, articleId } = this.$route.params;
      const path = route.path
        .replace(':slug', slug)
        .replace(':type', type)
        .replace(':id', id)
        .replace(':articleSlug', articleSlug)
        .replace(':articleType', articleType)
        .replace(':articleId', articleId);
      const dataEmbedUrl = `${window.location.origin}/embed-video${path}`;

      const src = `${dataEmbedUrl}?autoplay=true&muted=true&recommendationAutoplay=true`;
      const allowOptions = ['autoplay', 'clipboard-write', 'encrypted-media *', 'picture-in-picture'];

      return `<iframe id="${PLAYER_ID}" src="${src}" frameborder="0" scrolling="no" allow="${allowOptions.join('; ')}" allowfullscreen="" width="${EP_WIDTH}" height="${EP_HIGHT}"></iframe>`;
    },
  },
};
